export const storeAcceptedCookie = (isAccepted) => {
	localStorage.setItem("acceptedCookie", isAccepted ? "1" : "0");
}

export const getAcceptedCookie = () => {
	return !!parseInt(localStorage.getItem("acceptedCookie"), 10);
}